<template>
    <section class="reviews-list pt-60 pb-80 pt-md-80 pt-sm-40 pb-sm-40">
        <div class="container">
            <div class="reviews-list__top">
                <h2 class="reviews-list__title">Отзывы</h2>
                <div class="reviews-list__navigation" v-if="showControls">
                    <button @click="prev" class="prev" :disabled="swiperProgress <= 0"></button>
                    <button @click="next" class="next" :disabled="swiperProgress >= 1"></button>
                </div>
            </div>
            <div class="reviews-list__carousel">
                <div v-swiper:swiper="swiperOptions" @slide-change="onSlideChange">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(review, index) in reviews" :key="index">
                            <div class="reviews-list__content">
                                <review-text :review="review.desc" @clampchange="heightFix"></review-text>
                                <div class="reviews-list__author">{{ review.date }}</div>
                                <div class="reviews-list__author">{{ review.name }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import {directive} from 'vue-awesome-swiper';
import 'swiper/css/swiper.css'
import ReviewText from "../../../pnd/src/components/ReviewText";

export default {
    name: 'ReviewsList',
    props: {
        reviews: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            swiperOptions: {
                pagination: {
                    el: '.swiper-pagination',
                },
                autoHeight: true,
                calculateHeight: true,
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 60,
                        autoHeight: true,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 60,
                    },
                    1025: {
                        slidesPerView: 3,
                        spaceBetween: 70,
                    },
                },
            },
            swiperProgress: 0,
            showControls: false,
        }
    },
    methods: {
        prev() {
            this.swiper.slidePrev();
        },
        next() {
            this.swiper.slideNext();

        },
        onSlideChange() {
            this.swiperProgress = this.swiper.progress;
        },
        heightFix() {
            this.swiper.update();
        },
    },
    components: {
        ReviewText,
    },
    directives: {
        swiper: directive,
    },
    mounted() {
        if (this.reviews.length > this.swiperOptions.breakpoints[this.swiper.currentBreakpoint].slidesPerView) {
            this.showControls = true;
        }
        this.reviews.sort(function () {
            return Math.random() - 0.5
        });
    },
}
</script>
<style lang="scss">
@import "../../scss/base/include";

.reviews-list {
    @include mobile {
        position: relative;
    }

    &__title {
        @include tablet {
            font-size: 18px;
            line-height: 22px;
            margin-bottom: 30px;
        }
        @include mobile {
            font-size: 24px;
            line-height: 120%;
            margin-bottom: 0;
        }
    }

    &__top {
        position: relative;
        @include mobile {
            position: static;
        }
    }

    &__navigation {
        position: absolute;
        top: 50%;
        right: 0;
        z-index: 2;
        transform: translateY(-50%);
        @include tablet {
            top: -18px;
            transform: none;
        }
        @include mobile {
            transform: none;
            top: auto;
            bottom: 40px;
            right: 24px;
        }

        button {
            background-color: transparent;
            width: 39px;
            height: 39px;
            background-image: url(/local/templates/pnd/src/assets/i/arrow.svg);
            background-position: 58% 50%;
            background-repeat: no-repeat;
            background-size: 9px auto;
            border: solid 1px $list-bullet;
            outline: none;
            border-radius: 50%;
            cursor: pointer;

            &:disabled {
                cursor: default;
                opacity: 0.3;
                border-color: $border;
            }

            &.prev {
                transform: scale(-1, 1);
            }

            &.next {
                margin-left: 8px;
            }
        }
    }

    &__carousel {
        margin-top: 10px;
        margin-bottom: 0;
        @include tablet {
            margin-bottom: 0;
        }
        @include mobile {
            margin-top: 0;
        }
    }

    &__item {
        &-image {
            width: 220px;
            height: 222px;
            border-radius: 50%;
            margin-bottom: 15px;
            background-position: center;
            background-size: cover;
        }

        &-name {
            font-size: 16px;
            line-height: 26px;
            color: $gray;
            margin-bottom: 40px;
            @include tablet {
                margin-bottom: 20px;
            }
        }

        &-desc {
            font-size: 18px;
            line-height: 28px;
            color: $text-color;
            word-break: normal !important;
            transition: all ease .3s;
            margin-bottom: 10px;
            @include mobile {
                font-size: 16px;
            }

            p {
                margin-top: 0;
            }

            @include tablet {
                margin-bottom: 20px;
            }
        }

        &-stars {
            margin-bottom: 15px;

            img {
                margin-right: 5px;
                opacity: .2;

                &.active {
                    opacity: 1;
                }
            }
        }
    }

    &__text {
        font-size: 18px;
        line-height: 29px;
        margin-bottom: 19px;
        @include tablet {
            font-size: 14px;
            line-height: 160%;
            margin-bottom: 8px;
        }
    }

    &__author {
        font-size: 14px;
        line-height: 142.9%;
        color: $gray;
    }

    &__content {
        @include mobile {
            background-color: $white-true;
            box-shadow: 10px 14px 50px rgba(229, 233, 246, 0.8);
            border-radius: 20px;
            padding: 30px 20px 46px;
        }
    }

    .swiper-container {
        @include mobile {
            margin: 0 -#{$inner-pd-mob};
            padding: 15px $inner-pd-mob 58px;
        }
    }
}
</style>
